/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useRef } from 'react'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'

import RenewForm from 'containers/services/form/renewForm'
import { FormikProps } from 'formik'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    id: number,
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function RenewLightbox({ id, status, close }: Props) {
    const formRef = useRef<FormikProps<{ billing_cycle_id: number }>>(null)

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            title={'Renew Service'}
            description={'Keep a good thing going by renewing your service today.'}
            content={<RenewForm id={id} form={formRef} close={close}/>}
            conditions={{ state: status, action: () => close() }}
            links={[]}
            actions={[
                {
                    label: 'Back',
                    color: 'secondary',
                    func: () => close()
                },
                {
                    label: 'Renew',
                    color: 'primary',
                    type: 'submit',
                    form: 'renewForm'
                }
            ]}
        />
    )
}
